<template>
	<!-- sökväg / reload-previous-next -->
	<div class="flexcenter" style="align-items: start;">
		<SelectCategoryBR3 :categoryModel="this.categoryModel" :category="this.category"
			@categorySelected="(category) => this.$emit('categorySelected', category)"
			style="z-index:5;flex-grow:1;overflow-x:scroll;" :showArrow="false" />

		<div id="previousButton" v-if="this.previousProduct" @click="this.$emit('previous')" style="padding:5px;">
			<Icon fileName="w3_chevron_left_dark" style="width:10px;height:15px;"
				:title="'&laquo; Visa föregående i sökresultatet\n' + this.previousProduct?.name" />
		</div>

		<div id="nextButton" v-if="this.nextProduct" @click="this.$emit('next')" style="padding:5px;">
			<Icon fileName="w3_chevron_right_dark" style="width:10px;height:15px;"
				:title="'Visa nästa i sökresultatet &raquo;\n' + this.nextProduct?.name" />
		</div>

		<Circle v-if="!this" fileName="w3_reload_white" :spinning="this.productSpinner" color="--bg-light" padding="20%" size="26px"
			@click="this.$emit('reload')" />


	</div>
</template>
<script>

import SelectCategoryBR3 from "@/components/product/search/SelectCategoryBR3.vue";

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
//import { logMixin } from "@/mixins/logMixin.js";

export default {
	name: "BreadcrumbToolbar2",
	components: { SelectCategoryBR3  },
	mixins: [],
	props: {
		categoryModel: Object,
		category: Object,
		previousProduct: Object,
		nextProduct: Object,
		//productSpinner: Boolean

	},
	data() {
		return {

		};
	},
	computed: {

		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });


	},
	created() {

	}
};
</script>

<style scoped>

div#previousButton,
div#nextButton {
	background: white;
	border: 1px solid var(--grey-4);
	display: flex;
	align-items: center;
	border-radius: 5px;
	padding-left: 5px;
	padding-right: 5px
}

</style>